import {
  GET,
  APPROVE,
  CANCEL_APPROVAL,
  CLEAR_APPROVAL_SUMMARY
} from '@hobs/constants/approvalSummary';
import { actionCreator } from '@hobs/actions/utils/utils';

export const getApprovalSummary = () =>
  actionCreator('StatementOfRequirements/ApprovalSummary', GET);

export const approve = body =>
  actionCreator('StatementOfRequirements/ApprovalSummary/Approve', APPROVE, {
    body: body,
    method: 'PUT'
  });

export const cancelApproval = body =>
  actionCreator(
    'StatementOfRequirements/ApprovalSummary/CancelApproval',
    CANCEL_APPROVAL,
    { body: body, method: 'PUT' }
  );

export function clearApprovalSummary() {
  return dispatch => {
    dispatch({ type: CLEAR_APPROVAL_SUMMARY.SUCCESS });
  };
}
